<div class="file-names">
  <div class="file" *ngFor="let projectFile of checkItem.files; trackBy: trackEntityById">
    <div class="file-icon">
    </div>
    <div class="file-name">
      <span (click)="openFile(projectFile)">{{projectFile?.name}}</span>
    </div>

    <div class="file-info">
      {{projectFile.uploadTime | date: 'MMM dd, yyyy'}}
    </div>

    <span class="delete-icon" (click)="deleteFile(projectFile)">
			<mat-icon>clear</mat-icon>
		</span>
  </div>
</div>

<mat-progress-bar *ngIf="progressBar > 0" mode="determinate" value="{{progressBar}}">
</mat-progress-bar>
